export const isLoggedIn = () => {
    const token = localStorage.getItem('care_token');
    return token ? true : false;
}

export const isAdminLoggedIn = () => {
    const token = localStorage.getItem('care_admin_token');
    return token ? true : false;
}